import type { StationStatusData } from '../../../types/weatherData';

/**
 * The rain figure shown atop the station detail rain graph: a 24-hour TOTAL,
 * summed from the hourly precipitation series.
 *
 * Deliberately the opposite of `getLatestReadout` (see #675). The temperature,
 * humidity and wind graphs show the newest single reading and must be taken
 * from `latestReading`, never from the trend series. Rain is different: a
 * single hour's reading says almost nothing — it is nearly always 0 — and the
 * useful figure is the accumulation across the window.
 *
 * Returns null when the station reported no precipitation series at all, which
 * is not the same as a dry window and must not be rendered as 0.0mm.
 */
export function getRain24hTotal(status: StationStatusData): number | null {
    const series = status.trends?.precipitation;
    if (!series || series.length === 0) return null;

    const readings = series.filter((p) => p.value !== null && p.value !== undefined);
    if (readings.length === 0) return null;

    const total = readings.reduce((sum, p) => sum + p.value, 0);
    return Math.round(total * 10) / 10;
}
